"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LeftPanel = void 0;
var _components = require("@ori-ui/components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../../../contexts");
var _hooks = require("../../../../hooks");
var _models = require("../../../../models");
var _PickupPointCards = require("../PickupPointCards");
var _Search = require("../Search");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const LeftPanel = (param)=>{
    let { onPickupPointsListClick } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const { translations } = (0, _hooks.useTranslations)();
    const { selectedDelivery, onDeliveryItemActivation, togglePickupPointsDialog } = (0, _contexts.useMap)();
    const { pickupPoints, isLoading } = (0, _contexts.usePickupPoints)();
    const selectedPickupPoint = (0, _react.useMemo)(()=>pickupPoints.find((point)=>point.deliveryChannelId === selectedDelivery), [
        pickupPoints,
        selectedDelivery
    ]);
    const onPickupPointItemConfirmation = (0, _react.useCallback)(()=>{
        var _selectedPickupPoint_estimatedDeliveryDate;
        if (!selectedPickupPoint) {
            return;
        }
        var _selectedPickupPoint_estimatedDeliveryDate_toString, _selectedPickupPoint_telephoneNumber;
        onDeliveryItemActivation({
            deliveryChannelId: selectedPickupPoint.deliveryChannelId,
            addressId: selectedPickupPoint.addressId,
            deliveryMethod: selectedPickupPoint.deliveryMethod,
            city: selectedPickupPoint.city,
            streetAddress: selectedPickupPoint.streetAddress,
            deliveryFee: selectedPickupPoint.shippingFee,
            estimatedDelivery: (_selectedPickupPoint_estimatedDeliveryDate_toString = (_selectedPickupPoint_estimatedDeliveryDate = selectedPickupPoint.estimatedDeliveryDate) === null || _selectedPickupPoint_estimatedDeliveryDate === void 0 ? void 0 : _selectedPickupPoint_estimatedDeliveryDate.toString()) !== null && _selectedPickupPoint_estimatedDeliveryDate_toString !== void 0 ? _selectedPickupPoint_estimatedDeliveryDate_toString : '',
            hintMessages: [],
            isAllowed: true,
            isShippingJoker: selectedPickupPoint.isShippingJoker,
            isDefault: false,
            isLastUsed: false,
            isPrimaryAddress: false,
            name: selectedPickupPoint.description,
            description: selectedPickupPoint.description,
            zipCode: selectedPickupPoint.zipcode,
            telephoneNumber: (_selectedPickupPoint_telephoneNumber = selectedPickupPoint.telephoneNumber) !== null && _selectedPickupPoint_telephoneNumber !== void 0 ? _selectedPickupPoint_telephoneNumber : ''
        });
        togglePickupPointsDialog();
    }, [
        selectedPickupPoint,
        onDeliveryItemActivation,
        togglePickupPointsDialog
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.LeftPanelRoot, {
        "data-testid": getTestId(_models.TestId.SelectPickupPointDialogLeftMenu),
        onClick: onPickupPointsListClick,
        onTouchStart: onPickupPointsListClick,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Search.Search, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PickupPointCards.PickupPointCards, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.ConfirmButtonWrapper, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Button, {
                    fullWidth: true,
                    maxWidth: "500px",
                    "data-testid": getTestId(_models.TestId.SelectPickupPointDialoConfirmButton),
                    variant: "contained",
                    color: "primary",
                    disabled: !selectedPickupPoint,
                    loading: isLoading,
                    onClick: onPickupPointItemConfirmation,
                    children: translations.confirm
                })
            })
        ]
    });
};
exports.LeftPanel = LeftPanel;
